export default __webpack_public_path__ + "static/media/background.adff3ea9.svg";